import axios from 'axios';
import { CognitoUtils } from 'top-app-manager';
import { authConfig as config } from '../index';
import * as appConfig from '../config/app-config.json';

axios.interceptors.request.use(async (config) => {
    if (config.method !== 'OPTIONS') {
        let session = localStorage.getItem('session');
        let decodedSession = session === null ? session : JSON.parse(session);
        if(session !== null) {
            config.headers.Authorization = `Bearer ${decodedSession.credentials.idToken}`
            config.headers['Content-Type'] = 'application/json';
        } else {
            // document.location.href = CognitoUtils.getCognitoSignInUri();
        }

        return config;
    }
    return config;
});

axios.interceptors.response.use(undefined, (error) => {
   if(error.response && error.response.status === 401) {
        let session = localStorage.getItem('session');
        let decodedSession = session === null ? session : JSON.parse(session);
        fetch(`https://cognito-idp.${config.region}.amazonaws.com/`, {
            headers: {
                "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
                "Content-Type": "application/x-amz-json-1.1",
            },
            mode: 'cors',
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                ClientId: `${config.clientId}`,
                AuthFlow: 'REFRESH_TOKEN_AUTH',
                AuthParameters: {
                    REFRESH_TOKEN: (decodedSession === null) ? '' : decodedSession.credentials.refreshToken
                }
            }),
        }).then((res) => {
            return res.json();
        }).then(data => {
            if(decodedSession === null) {
                // document.location.href = CognitoUtils.getCognitoSignInUri();
            } else {
                if(!data.AuthenticationResult) {
                    localStorage.removeItem('session');
                    // document.location.href = CognitoUtils.getCognitoSignInUri();
                } else {
                    decodedSession.credentials.idToken = data.AuthenticationResult.IdToken;
                    localStorage.setItem('session', JSON.stringify(decodedSession) );
                    document.location.reload();
                }

            }

            
        }, () => {
            //document.location.href = CognitoUtils.getCognitoSignInUri();
        });
   } else if(error.response && error.response.status === 403) {
       document.location.href = appConfig.noRoleRedirectUrl;
   }
});

export default axios;